import logo from "../assets/CIVICX GREEN 2.png";
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function Footer() {
  return (
    <footer className="bg-black text-white px-5 px-lg-0 py-5 py-lg-8 ">
      <div className="container py-lg-5">
        <div className="row g-4 justify-content-between">
          {/* Logo */}
          <div className="col-12 col-md-2 d-none d-lg-block text-center text-md-start">
            <img src={logo} alt="CivicX Logo" style={{ height: "48px" }} />
          </div>

          {/* Quick Links */}
          <div className="col-12 col-md-2">
            <h6 className="text-white fw-bold mb-3"> </h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Home
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  How It Works
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Features
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  What You Can Report
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  FAQs
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div className="col-12 col-md-2">
            <h6 className="text-success fw-bold mb-3">Help</h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  FAQs
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Technical Support
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="col-12 col-md-2">
            <h6 className="text-success fw-bold mb-3">Connect with Us</h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://play.google.com/" className="text-white text-decoration-none">
                  X
                </a>
              </li>
            </ul>
          </div>

          {/* App Buttons */}
          <div className="col-12 col-md-3 text-center text-md-end">
            <div className="d-flex  justify-content-center align-items-center justify-content-md-end gap-3 mt-3 mt-md-0">
              <a href="https://play.google.com/">
                <img
                  src={googleImg}
                  alt="Google Play"
                  style={{ height: "42px" }}
                />
              </a>
              <a href="https://play.google.com/">
                <img
                  src={appStoreImg}
                  alt="App Store"
                  style={{ height: "42px" }}
                />
              </a>
            </div>
            <address className="mt-3 text-white small">
              Suit 37 K 30 Mall, Goke Adegoroye close, Wuye, Abuja, Nigeria
            </address>

            
          </div>
          
           
        </div>

        {/* Bottom Centered Logo */}
        <div className="text-center d-lg-none mt-5">
          <img src={logo} alt="CivicX" style={{ height: "48px" }} />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
